import { render, staticRenderFns } from "./ElementTargetTableColumn.vue?vue&type=template&id=db2497d6&scoped=true"
import script from "./ElementTargetTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementTargetTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementTargetTableColumn.vue?vue&type=style&index=0&id=db2497d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2497d6",
  null
  
)

export default component.exports